export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/f9541d360f96791aa3f0dd381d4000ad.png";